import { useState } from "react";
import { useFetch, fmtDate, usd } from "@/lib/api";
import { PageHeader, Panel, Badge, Stat } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function AuditSpend() {
  const [q, setQ] = useState("");
  const { data: logs } = useFetch(`/audit?actor_q=${encodeURIComponent(q)}`);
  const { data: sp } = useFetch("/spend");
  return (
    <div data-testid="audit-page">
      <PageHeader eyebrow="G04 · G06 · Audit & cost governance" title="Every action, every cent." desc="Model/API delivery cost is metered per purpose and campaign. Hard limits stop generation loops." />
      <Tabs defaultValue="spend">
        <TabsList><TabsTrigger value="spend" data-testid="tab-spend">Spend</TabsTrigger><TabsTrigger value="audit" data-testid="tab-audit">Audit log</TabsTrigger></TabsList>
        <TabsContent value="spend">
          {sp && <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 my-4">
              <Stat testid="spend-month" label="Spend this month" value={usd(sp.month_usd)} sub={`budget $${sp.budget_usd}`} />
              <Stat testid="spend-ai" label="AI model spend" value={usd(sp.ai_month_usd)} sub={`hard limit $${sp.ai_budget_usd}`} tone={sp.ai_month_usd > sp.ai_budget_usd * 0.8 ? "text-[#FFB020]" : ""} />
              <Stat testid="spend-forecast" label="Month forecast" value={usd(sp.forecast_month_usd)} />
              <Stat label="Ledger entries" value={sp.recent.length} sub="latest 100" />
            </div>
            <div className="grid lg:grid-cols-2 gap-3">
              <Panel title="By category"><table className="w-full text-sm">{sp.by_category.map((c) => <tbody key={c._id}><tr className="border-b border-border/60"><td className="py-2">{c._id}</td><td className="font-mono text-right">{c.units.toLocaleString()} units</td><td className="font-mono text-right">{usd(c.usd)}</td></tr></tbody>)}</table></Panel>
              <Panel title="By purpose"><table className="w-full text-sm">{sp.by_purpose.map((c) => <tbody key={c._id || "none"}><tr className="border-b border-border/60"><td className="py-2">{c._id || "—"}</td><td className="font-mono text-right">{c.n} calls</td><td className="font-mono text-right">{usd(c.usd)}</td></tr></tbody>)}</table></Panel>
            </div>
            <p className="text-[11px] text-zinc-500 mt-3">Model costs are estimated from token counts at list prices; reconcile against provider invoices.</p>
          </>}
        </TabsContent>
        <TabsContent value="audit">
          <Input data-testid="audit-filter-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by actor (e.g. Conversation agent)" className="w-80 bg-black my-4" />
          <div className="border border-border rounded-md divide-y divide-border/60 text-xs font-mono" data-testid="audit-log">
            {(logs || []).map((l) => (
              <div key={l.id} className="flex gap-3 px-4 py-2 items-center"><span className="text-zinc-500 w-28 shrink-0">{fmtDate(l.created_at)}</span><span className="text-[#3395FF] w-48 shrink-0 truncate">{l.actor}</span><span className="w-44 shrink-0">{l.action}</span><span className="flex-1 text-zinc-400 truncate">{l.detail}</span><Badge v={l.policy_result} tone={l.policy_result === "allowed" ? "green" : "red"} /></div>
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
